import React, { Fragment, useState, useEffect } from 'react';

import { getIndentClass } from '../../utils/styleUtils';

import SponsorRow from './SponsorRow';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

export default function SponsorCostcenterRow(props) {
    const [showCostCenter, setShowCostCenter] = useState(false);

    // Handle expand all trigger from parent with staggered updates
    useEffect(() => {
        const t = props.expandAllTrigger;
        if (!t?.version) return;

        if (t.batch === 'costcenters') {
            setShowCostCenter(t.expanded);
        }
    }, [props.expandAllTrigger?.version]);

    // Calculate indentation level
    const indentLevel = props.indentLevel;
    const childIndentLevel = indentLevel + 1;

    return (
        <>
            <tr className="!tw-bg-blue-100">
                <td className="tw-font-bold tw-cursor-pointer !tw-border-r-0" onClick={() => setShowCostCenter(!showCostCenter)}>
                    <div className={`tw-flex tw-items-center tw-gap-x-1.5 ${getIndentClass(indentLevel)}`}>
                        <div className="!tw-text-blue">{props.costcenter.name}</div>
                        <div>{showCostCenter ? <ChevronUpIcon /> : <ChevronDownIcon />}</div>
                    </div>
                </td>
                <td className="tw-p-4 !tw-border-x-0"></td>
                <td className="tw-font-bold tw-cursor-pointer tw-border-r-2" onClick={() => setShowCostCenter(!showCostCenter)}></td>
                <td
                    colSpan={props.maxSponsorMilestonesCount * 4 + 3}
                    className="tw-font-bold tw-cursor-pointer !tw-border-l-0"
                    onClick={() => setShowCostCenter(!showCostCenter)}
                ></td>
            </tr>

            {showCostCenter && (
                <Fragment>
                    {props.costcenter.sponsors &&
                        props.costcenter.sponsors.length > 0 &&
                        props.costcenter.sponsors.map((sponsor) => {
                            return (
                                <SponsorRow
                                    SponsorMilestoneUpdateUrl={props.SponsorMilestoneUpdateUrl}
                                    minDate={props.minDate}
                                    maxDate={props.maxDate}
                                    key={`tr_sponsor_${sponsor.id}`}
                                    sponsor={sponsor}
                                    maxSponsorMilestonesCount={props.maxSponsorMilestonesCount}
                                    increaseMaxMilestonesCount={props.increaseMaxMilestonesCount}
                                    editingSponsorId={props.editingSponsorId}
                                    editingType={props.editingType}
                                    editingMilestoneId={props.editingMilestoneId}
                                    editingMilestoneType={props.editingMilestoneType}
                                    setSponsorEditing={props.setSponsorEditing}
                                    modalShow={props.modalShow}
                                    fetchCentralCashflow={props.fetchCentralCashflow}
                                    canEdit={props.canEdit}
                                    isCostcenterSponsor={props.costcentersColor}
                                    milestoneType={props.milestoneType}
                                    periods={props.periods}
                                    setLoading={props.setLoading}
                                    indentLevel={childIndentLevel}
                                    expandAllTrigger={props.expandAllTrigger}
                                    editAllTrigger={props.editAllTrigger}
                                />
                            );
                        })}
                </Fragment>
            )}
        </>
    );
}
